<template>
  <div class="p-product">
    <Banner :type="type"/>
    <template v-if="type === 'group'">
      <v-container class="product-content">
        <classify
          :categorySub="categorySub"
          :categoryImages="categoryImages"
          @toProductDetail="toProductDetail"
        />
        <div class="company-introduce">
          <h2>企业优选的产品</h2>
          <p>为企业提供保险一站直达服务，便捷实现企业发展中所需的保障， 通过定制化的方式， 为企业解决运营中的风险问题</p>
        </div>
        <product_classify
          :categorySub="categorySub"
          :categoryImages="categoryImages"
          @toProductDetail="toProductDetail"
        />
      </v-container>
    </template>
    <template v-else>
      <v-container class="p-product-list">
        <div>
          <ListItem v-for="item in productsList" :key="item.id" :product="item" />
        </div>
      </v-container>
    </template>
  </div>
</template>

<script>
import ListItem from "./components/ListItem";
import Navigation from "./components/Navigation";
import Banner from "./components/Banner";
import Classify from "./classify";
import Product_classify from "./components/product_classify";
export default {
  components: {
    Product_classify,
    Classify,
    Banner,
    Navigation,
    ListItem
  },
  props: {
    type: {
      type: String,
      default: "group",
    }
  },
  data() {
    return {
      tabActive: 0,
      categorySub: [],
      categoryImages: {
        staff_welfare: {
          "big": "/images/web_product/ygfl.png",
          "small": "/images/web_product/ygfl-small.png",
        },
        company_duty: {
          "big": "/images/web_product/qyzr.png",
          "small": "/images/web_product/qyzr-small.png",
        },
        company_assets: {
          "big": "/images/web_product/qycc.png",
          "small": "/images/web_product/qycc-small.png",
        },
      },
      productsList: [],
    };
  },
  mounted() {
    //获取分类
    this.$store.dispatch("getDictsCategorys").then(() => {
      this.categorySub = this.$store.getters.getCategoryTop("product_category");
    });
    if (this.type !== 'group'){
      this.getList();
    }
  },
  computed: {
    isGroup() {
      return this.type === "group";
    },
    categories() {
      const categories = this.$store.getters.getCategoryList(this.type, true);
      return categories;
    },
  },
  watch:{
    type(newValue){
      if (newValue !== "group"){
        this.getList();
      }
    }
  },
  methods:{
    toProductDetail(category){
      this.$router.push("/product/classify/"+category);
    },
    getList(){
      let form = {
        code: this.type
      }
      this.$axios.get("/json/person_productlist.json").then(res => {
        this.productsList = res[form.code];
        this.productsList = this.productsList.map(item => {
          if (item.productDetailBo.hasOwnProperty("features") && item.productDetailBo.features !== ""){
            item.productDetailBo.features = JSON.parse(item.productDetailBo.features);
          }
          if (item.productDetailBo.hasOwnProperty("conditions") && item.productDetailBo.conditions !== ""){
            item.productDetailBo.conditions = JSON.parse(item.productDetailBo.conditions);
          }
          return item;
        })
      });
    }
  }
};
</script>

<style lang="scss">
.p-product {
  h1 {
    font-size: 2.5em;
  }
}
.p-product-list {
  // tabs 少于两个的时候隐藏
  .hide-tabs_bar {
    .v-tabs__bar {
      display: none;
    }
  }
  .category-tabs {
    .v-tabs__bar {
      // padding: 8px 20px;
      padding-left: 20px;
      .v-tabs__item {
        font-size: 14px;
        // color: $font-color;
        // opacity: 1;
      }
      // tabs 文字下的滑动线
      .v-tabs__slider {
        width: 32px;
        margin: auto;
      }
    }
  }
}
  .company-introduce{
    width: 80%;
    margin: 60px auto;
    h2{
      text-align: center;
      font-size: 37px;
      margin-bottom: 24px;
    }
    p {
      text-align: center;
      font-size: 24px;
    }
  }
</style>


